// ReportDisplay.tsx
import React from 'react';
import ReportTable from './ReportTable';
import ReportPieChart from './ReportPieChart';
import ReportBarChart from './ReportBarChart';

interface ReportDisplayProps {
    reportResult: ReportResult | null;
}

const ReportDisplay: React.FC<ReportDisplayProps> = ({ reportResult }) => {
    if (!reportResult) {
        return <div>No report data available.</div>;
    }

    switch (reportResult.format) {
        case 'Table':
            return <ReportTable data={reportResult.data} />;
        case 'PieChart':
            return <ReportPieChart data={reportResult.data} />;
        case 'BarChart':
            return <ReportBarChart data={reportResult.data} />;
        default:
            return <div>Invalid report format.</div>;
    }
};

export default ReportDisplay;